import { NotificationLevel, NotificationsService } from './../../../../services/api/notifications/notifications.service';
import { PartyService } from './../../../../services/api/party/party.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Party } from 'src/app/models/party-manager/party';

@Component({
  selector: 'app-delete-party',
  templateUrl: './delete-party.component.html',
  styleUrls: ['./delete-party.component.scss']
})
export class DeletePartyComponent implements OnInit {

  constructor(
    private partyService:PartyService,
    private notificationsService:NotificationsService,
    public dialogRef: MatDialogRef<DeletePartyComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      party: Party;
    }) { }

  ngOnInit() {
  }

  confirm(){
    this.partyService.delete(this.data.party.namingId).subscribe(
      () => {
        this.notificationsService.showNotification(`Operador ${this.data.party.name} se elimino correctamente`, NotificationLevel.SUCCESS);
        this.dialogRef.close();
      },
      (error) => {
        this.notificationsService.showNotification(
          `Ha habido un problema al eliminar el operador:\n${error.error.errorDesc.errorDesc}`, NotificationLevel.ERROR);
      });;
  }

}
